import { Seo } from '@/components/seo/Seo';
import { ns, useT } from '@/i18n';
import type { ShellTitle } from './shell/shellConfig';

/** Head tags (`noindex`) of a private page the router adds beside it, titled in the current language. */
export function PrivateSeo({ title, path }: { title: ShellTitle; path: string }) {
  const t = useT(ns.shell);
  return <Seo title={t(title)} path={path} noindex />;
}
